/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdditionalNotesResponseDto,
  EnvironmentToxinsResponseDto,
  ErrorResponse,
  FamilyHistoryResponseDto,
  FunctionalLifestyleResponseDto,
  GeneralInformationResponseDto,
  GoalsOfTreatmentResponseDto,
  MedicalHistoryResponseDto,
  MedicationStatementResponseDto,
  NutritionAndDietResponseDto,
  PresentingConcernsResponseDto,
  SocialHistoryResponseDto,
} from '../models/index';
import {
    AdditionalNotesResponseDtoFromJSON,
    AdditionalNotesResponseDtoToJSON,
    EnvironmentToxinsResponseDtoFromJSON,
    EnvironmentToxinsResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FamilyHistoryResponseDtoFromJSON,
    FamilyHistoryResponseDtoToJSON,
    FunctionalLifestyleResponseDtoFromJSON,
    FunctionalLifestyleResponseDtoToJSON,
    GeneralInformationResponseDtoFromJSON,
    GeneralInformationResponseDtoToJSON,
    GoalsOfTreatmentResponseDtoFromJSON,
    GoalsOfTreatmentResponseDtoToJSON,
    MedicalHistoryResponseDtoFromJSON,
    MedicalHistoryResponseDtoToJSON,
    MedicationStatementResponseDtoFromJSON,
    MedicationStatementResponseDtoToJSON,
    NutritionAndDietResponseDtoFromJSON,
    NutritionAndDietResponseDtoToJSON,
    PresentingConcernsResponseDtoFromJSON,
    PresentingConcernsResponseDtoToJSON,
    SocialHistoryResponseDtoFromJSON,
    SocialHistoryResponseDtoToJSON,
} from '../models/index';

export interface DeleteInstructionForAdminRequest {
    instructionId: string;
    patientId: string;
}

export interface DeleteTreatmentPlanForAdminRequest {
    treatmentPlanId: string;
    patientId: string;
}

export interface GetPatientAdditionalNotesForAdminRequest {
    patientId: string;
}

export interface GetPatientEnvironmentToxinsForAdminRequest {
    patientId: string;
}

export interface GetPatientFamilyHistoryForAdminRequest {
    patientId: string;
}

export interface GetPatientFunctionalLifestyleForAdminRequest {
    patientId: string;
}

export interface GetPatientGeneralInformationForAdminRequest {
    patientId: string;
}

export interface GetPatientGoalsOfTreatmentForAdminRequest {
    patientId: string;
}

export interface GetPatientMedicalHistoryForAdminRequest {
    patientId: string;
}

export interface GetPatientMedicationsForAdminRequest {
    patientId: string;
}

export interface GetPatientNutritionAndDietForAdminRequest {
    patientId: string;
}

export interface GetPatientPresentingConcernsForAdminRequest {
    patientId: string;
}

export interface GetPatientSocialHistoryForAdminRequest {
    patientId: string;
}

/**
 * 
 */
export class AdminPatientDetailApi extends runtime.BaseAPI {

    /**
     * Soft-deletes an instruction by ID. Admin can delete any instruction regardless of ownership.
     * Delete an instruction (Admin only)
     */
    async deleteInstructionForAdminRaw(requestParameters: DeleteInstructionForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['instructionId'] == null) {
            throw new runtime.RequiredError(
                'instructionId',
                'Required parameter "instructionId" was null or undefined when calling deleteInstructionForAdmin().'
            );
        }

        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling deleteInstructionForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/instructions/{instructionId}`.replace(`{${"instructionId"}}`, encodeURIComponent(String(requestParameters['instructionId']))).replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Soft-deletes an instruction by ID. Admin can delete any instruction regardless of ownership.
     * Delete an instruction (Admin only)
     */
    async deleteInstructionForAdmin(requestParameters: DeleteInstructionForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteInstructionForAdminRaw(requestParameters, initOverrides);
    }

    /**
     * Soft-deletes a treatment plan by ID. Admin can delete any treatment plan regardless of ownership.
     * Delete a treatment plan (Admin only)
     */
    async deleteTreatmentPlanForAdminRaw(requestParameters: DeleteTreatmentPlanForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['treatmentPlanId'] == null) {
            throw new runtime.RequiredError(
                'treatmentPlanId',
                'Required parameter "treatmentPlanId" was null or undefined when calling deleteTreatmentPlanForAdmin().'
            );
        }

        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling deleteTreatmentPlanForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/treatment-plans/{treatmentPlanId}`.replace(`{${"treatmentPlanId"}}`, encodeURIComponent(String(requestParameters['treatmentPlanId']))).replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Soft-deletes a treatment plan by ID. Admin can delete any treatment plan regardless of ownership.
     * Delete a treatment plan (Admin only)
     */
    async deleteTreatmentPlanForAdmin(requestParameters: DeleteTreatmentPlanForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTreatmentPlanForAdminRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve additional practitioner notes stored for a patient profile
     * Get patient additional notes (admin)
     */
    async getPatientAdditionalNotesForAdminRaw(requestParameters: GetPatientAdditionalNotesForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdditionalNotesResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientAdditionalNotesForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/additional-notes`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdditionalNotesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve additional practitioner notes stored for a patient profile
     * Get patient additional notes (admin)
     */
    async getPatientAdditionalNotesForAdmin(requestParameters: GetPatientAdditionalNotesForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdditionalNotesResponseDto> {
        const response = await this.getPatientAdditionalNotesForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve information about a patient\'s environmental exposure and toxins
     * Get patient environment & toxins data (admin)
     */
    async getPatientEnvironmentToxinsForAdminRaw(requestParameters: GetPatientEnvironmentToxinsForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EnvironmentToxinsResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientEnvironmentToxinsForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/environment-toxins`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EnvironmentToxinsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve information about a patient\'s environmental exposure and toxins
     * Get patient environment & toxins data (admin)
     */
    async getPatientEnvironmentToxinsForAdmin(requestParameters: GetPatientEnvironmentToxinsForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EnvironmentToxinsResponseDto> {
        const response = await this.getPatientEnvironmentToxinsForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a patient\'s family medical history information as an administrator
     * Get patient family history (admin)
     */
    async getPatientFamilyHistoryForAdminRaw(requestParameters: GetPatientFamilyHistoryForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FamilyHistoryResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientFamilyHistoryForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/family-history`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FamilyHistoryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve a patient\'s family medical history information as an administrator
     * Get patient family history (admin)
     */
    async getPatientFamilyHistoryForAdmin(requestParameters: GetPatientFamilyHistoryForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FamilyHistoryResponseDto> {
        const response = await this.getPatientFamilyHistoryForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the functional and lifestyle questionnaire responses for a patient
     * Get patient functional & lifestyle assessment (admin)
     */
    async getPatientFunctionalLifestyleForAdminRaw(requestParameters: GetPatientFunctionalLifestyleForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FunctionalLifestyleResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientFunctionalLifestyleForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/functional-lifestyle`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FunctionalLifestyleResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve the functional and lifestyle questionnaire responses for a patient
     * Get patient functional & lifestyle assessment (admin)
     */
    async getPatientFunctionalLifestyleForAdmin(requestParameters: GetPatientFunctionalLifestyleForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FunctionalLifestyleResponseDto> {
        const response = await this.getPatientFunctionalLifestyleForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve core demographic details for a patient as an administrator
     * Get patient general information (admin)
     */
    async getPatientGeneralInformationForAdminRaw(requestParameters: GetPatientGeneralInformationForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneralInformationResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientGeneralInformationForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/general-information`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeneralInformationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve core demographic details for a patient as an administrator
     * Get patient general information (admin)
     */
    async getPatientGeneralInformationForAdmin(requestParameters: GetPatientGeneralInformationForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneralInformationResponseDto> {
        const response = await this.getPatientGeneralInformationForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the goals of treatment defined for a patient as an administrator
     * Get patient goals of treatment (admin)
     */
    async getPatientGoalsOfTreatmentForAdminRaw(requestParameters: GetPatientGoalsOfTreatmentForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoalsOfTreatmentResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientGoalsOfTreatmentForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/goals-of-treatment`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoalsOfTreatmentResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve the goals of treatment defined for a patient as an administrator
     * Get patient goals of treatment (admin)
     */
    async getPatientGoalsOfTreatmentForAdmin(requestParameters: GetPatientGoalsOfTreatmentForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoalsOfTreatmentResponseDto> {
        const response = await this.getPatientGoalsOfTreatmentForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the complete medical history questionnaire for a patient
     * Get patient medical history (admin)
     */
    async getPatientMedicalHistoryForAdminRaw(requestParameters: GetPatientMedicalHistoryForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicalHistoryResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientMedicalHistoryForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/medical-history`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicalHistoryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve the complete medical history questionnaire for a patient
     * Get patient medical history (admin)
     */
    async getPatientMedicalHistoryForAdmin(requestParameters: GetPatientMedicalHistoryForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicalHistoryResponseDto> {
        const response = await this.getPatientMedicalHistoryForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the list of medication statements recorded for a patient
     * Get patient medication statements (admin)
     */
    async getPatientMedicationsForAdminRaw(requestParameters: GetPatientMedicationsForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MedicationStatementResponseDto>>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientMedicationsForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/medication-statements`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicationStatementResponseDtoFromJSON));
    }

    /**
     * Retrieve the list of medication statements recorded for a patient
     * Get patient medication statements (admin)
     */
    async getPatientMedicationsForAdmin(requestParameters: GetPatientMedicationsForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MedicationStatementResponseDto>> {
        const response = await this.getPatientMedicationsForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve nutrition and diet questionnaire responses for a patient
     * Get patient nutrition & diet information (admin)
     */
    async getPatientNutritionAndDietForAdminRaw(requestParameters: GetPatientNutritionAndDietForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NutritionAndDietResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientNutritionAndDietForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/nutrition-diets`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NutritionAndDietResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve nutrition and diet questionnaire responses for a patient
     * Get patient nutrition & diet information (admin)
     */
    async getPatientNutritionAndDietForAdmin(requestParameters: GetPatientNutritionAndDietForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NutritionAndDietResponseDto> {
        const response = await this.getPatientNutritionAndDietForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve presenting concerns submitted by a patient for administrative review
     * Get patient presenting concerns (admin)
     */
    async getPatientPresentingConcernsForAdminRaw(requestParameters: GetPatientPresentingConcernsForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PresentingConcernsResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientPresentingConcernsForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/presenting-concerns`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PresentingConcernsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve presenting concerns submitted by a patient for administrative review
     * Get patient presenting concerns (admin)
     */
    async getPatientPresentingConcernsForAdmin(requestParameters: GetPatientPresentingConcernsForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PresentingConcernsResponseDto> {
        const response = await this.getPatientPresentingConcernsForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve social and lifestyle history information for a patient
     * Get patient social history (admin)
     */
    async getPatientSocialHistoryForAdminRaw(requestParameters: GetPatientSocialHistoryForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SocialHistoryResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientSocialHistoryForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}/social-history`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SocialHistoryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve social and lifestyle history information for a patient
     * Get patient social history (admin)
     */
    async getPatientSocialHistoryForAdmin(requestParameters: GetPatientSocialHistoryForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SocialHistoryResponseDto> {
        const response = await this.getPatientSocialHistoryForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
